module.exports = __webpack_public_path__ + "static/media/Ø3(5).ddb48ed2.png";